import { render } from "./PendingPayment.vue?vue&type=template&id=b3acdf9a&scoped=true"
import script from "./PendingPayment.vue?vue&type=script&lang=js"
export * from "./PendingPayment.vue?vue&type=script&lang=js"

import "./PendingPayment.vue?vue&type=style&index=0&id=b3acdf9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3acdf9a"]])

export default __exports__